var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C9.88459 20 9.76964 19.998 9.65517 19.9942V18.6139C9.76956 18.6184 9.88451 18.6207 10 18.6207C14.7611 18.6207 18.6207 14.7611 18.6207 10C18.6207 5.23892 14.7611 1.37931 10 1.37931C5.23892 1.37931 1.37931 5.23892 1.37931 10C1.37931 10.1155 1.38158 10.2304 1.38608 10.3448H0.00583387C0.00195506 10.2304 0 10.1154 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10.8333 9.16667V2.5H9.16667V10.8333H10.8333H15.8333V9.16667H10.8333ZM9.16667 15.4167C9.16667 17.948 7.11464 20 4.58333 20C2.05203 20 0 17.948 0 15.4167C0 12.8854 2.05203 10.8333 4.58333 10.8333C7.11464 10.8333 9.16667 12.8854 9.16667 15.4167ZM8.40278 15.4167C8.40278 17.5261 6.69275 19.2361 4.58333 19.2361C2.47391 19.2361 0.763889 17.5261 0.763889 15.4167C0.763889 13.3072 2.47391 11.5972 4.58333 11.5972C6.69275 11.5972 8.40278 13.3072 8.40278 15.4167ZM4.20139 15.0347V13.125H4.96528V15.0347H6.875V15.7986H4.96528V17.7083H4.20139V15.7986H2.29167V15.0347H4.20139Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateInspection);
export default __webpack_public_path__ + "static/media/CreateInspection.a10425e116ef27649fc2e52aca19b5b7.svg";
export { ForwardRef as ReactComponent };